/**
 * Reusable phone input with ISD dropdown + flag icons.
 *
 * Wraps `react-phone-number-input` so the rest of the app can import a single
 * shadcn-styled component and get:
 *   • Global country list (default: India +91) with searchable dropdown
 *   • Flag icon + ISD code on the left, national number on the right
 *   • E.164 output (e.g. "+919876543210") — exactly what Interakt / WhatsApp
 *     Cloud API / libphonenumber consume, so no reparsing on the backend
 *   • Validity check via `isValidPhoneNumber` helper (re-exported)
 *
 * Usage:
 *   <PhoneInput value={phone} onChange={setPhone} />            // E.164 string
 *   <PhoneInput value={phone} onChange={setPhone} defaultCountry="IN" />
 *   const ok = isValidPhoneNumber(phone)                          // boolean
 */
import React from 'react';
import RPNInput from 'react-phone-number-input';
import { isValidPhoneNumber as _isValid } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './phone-input.css';

export const isValidPhoneNumber = (v) => {
  if (!v) return false;
  try { return _isValid(v); } catch { return false; }
};

const PhoneInput = ({
  value,
  onChange,
  defaultCountry = 'IN',
  placeholder = 'Enter phone number',
  disabled = false,
  required = false,
  className = '',
  testid = 'phone-input',
  international = true,
  autoFocus = false,
}) => {
  return (
    <div className={`acf-phone-input ${className}`} data-testid={testid}>
      <RPNInput
        international={international}
        defaultCountry={defaultCountry}
        value={value || ''}
        onChange={(v) => onChange(v || '')}
        placeholder={placeholder}
        disabled={disabled}
        autoFocus={autoFocus}
        numberInputProps={{
          required,
          'data-testid': `${testid}-number`,
        }}
        countrySelectProps={{
          'data-testid': `${testid}-country`,
        }}
      />
    </div>
  );
};

export default PhoneInput;
